import { MDBAlert, MDBLoadingManagement } from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getExistingGreetingsInfo, getGreeting } from "../../apiclients/streamsapi_bridge";
import Greeting from "../../views/popups/mlib/Greeting";
import PopupLoader from "../../views/popups/PopupLoader";
import { Tooltip } from "react-tooltip";

// onEdit = 1( unavailbale, busy greeting.) 
// expected props = uniqueId, greetingType, greetingId, fileName , title, greetingMode
//[uniqueId, greetingType is mandatory]
// greetingMode =  Persionalized greeting =1  , Default = 2


/*
{
"greetings": {
  "busy": {
    "siteid": 4424,
    "filename": "sample3scopy.mp3",
    "greeting_type": 2,
    "greeting_id": 0,
    "id": 99
  }
} 
*/


export async function streamToBlob(stream) {
  const chunks = [];
  const reader = stream.getReader();

  while (true) {
    const { done, value } = await reader.read();
    if (done) {
      break;
    }
    chunks.push(value);
  }

  return new Blob(chunks, { type: 'application/octet-stream' });
}
export async function getAudioFile(uniqueId, greetingType, greetingId = 0, fileName = '', download, greetingObject) {
  try {
    let reqBodyInfo = {
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      greeting_type: greetingObject && greetingObject.uploadType === 3 ? greetingObject.greeting_type : greetingType,
      greeting_id: greetingId !==0 ? greetingId : greetingObject && greetingObject.uploadType === 3 ? greetingObject.greeting_id : 0,
      filename: greetingObject && greetingObject.uploadType === 3 ? greetingObject.filename : fileName,
      id: uniqueId,
      ...(download ? { isDownload: true } : {})

    }
    let apiResponse = await getGreeting(reqBodyInfo);
    if (apiResponse.status === 200) {
      //const fileUrl = URL.createObjectURL(await streamToBlob(apiResponse.body));
      const fileUrl = URL.createObjectURL(await apiResponse.blob());
      return fileUrl
    }
  } catch (error) {
    console.log(`Unable to load the audio file : ${error}`);
  }
  return '';
}
export async function getAudioFileNew(uniqueId, greetingType, greetingId = 0, fileName = '', download, greetingObject) {
  try {
    let reqBodyInfo = {
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      greeting_type: greetingType,
      greeting_id: greetingId !== 0 ? greetingId : greetingObject && greetingObject.uploadType === 3 ? greetingObject.greeting_id : 0,
      filename: greetingObject && greetingObject.uploadType === 3 ? greetingObject.filename : fileName,
      id: uniqueId,
      ...(download ? { isDownload: true } : {})
    }
    let apiResponse = await getGreeting(reqBodyInfo);
    return apiResponse;
  } catch (error) {
    console.log(`Unable to load the audio file : ${error}`);
  }
  return null;
}
export async function getAudioFileForTTS(uniqueId, greetingType, greetingId = 0, fileName = '', download, greetingObject) {
  try {
    let reqBodyInfo = {
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      greeting_type: greetingObject && greetingObject.uploadType === 3 && greetingObject.greeting_type ? greetingObject.greeting_type : greetingType,
      greeting_id: greetingId !==0 ? greetingId : greetingObject && greetingObject.uploadType === 3 ? greetingObject.greeting_id : 0,
      filename: greetingObject && greetingObject.uploadType === 3 ? greetingObject.filename : fileName,
      id: uniqueId,
      ...(download ? { isDownload: true } : {})

    }
    let apiResponse = await getGreeting(reqBodyInfo);
    return apiResponse;
  } catch (error) {
    console.log(`Unable to load the audio file : ${error}`);
  }
  return null;
}



export default function AudioPlayer(props) {

  const [playerPath, setPlayerPath] = useState(props.audioData ?? '');
  const [geetingTitle, setgeetingTitle] = useState(props?.greetingTitle ?? "");
  const [enableGreeting, setEnableGreeting] = useState(0);

  const [existingGreetings, setExistingGreetings] = useState([]);

  const [successMsg, setSuccessMsg] = useState('');

  const [greetingMode, setGreetingMode] = useState(props?.greetingMode ?? 2);
  const [ttswavFile, setttswavFile] = useState(null);
  // const [dynamicGreetingObject, setdynamicGreetingObject] = useState(null);
  const [greetingObject, setgreetingObject] = useState(props.greetingObject ? props.greetingObject : null);
   const [firstGreetFlag, setfirstGreetFlag] = useState(false);
   const [showLoader, setshowLoader] = useState(false);

  const { t } = useTranslation();

  const ChangeEnableGreeting = (whGreetingToEnable) => {
    setEnableGreeting(enableGreeting != 0 ? 0 : whGreetingToEnable);
  }

  async function streamResponseToPlayer(apiResponse, onDone) {
    try {
      const reader = apiResponse.body.getReader();
      const chunks = [];
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        if (value) chunks.push(value);
      }
      if (onDone) onDone(chunks);
      // Detect actual format from magic bytes so the blob has the correct MIME type.
      // A wrong MIME type causes the browser to fire an error on preload="metadata",
      // which shows "--:--" for the duration until play is manually triggered.
      const hdr = chunks[0];
      let mimeType = 'audio/mpeg';
      if (hdr?.length >= 4) {
        if (hdr[0] === 0x1A && hdr[1] === 0x45 && hdr[2] === 0xDF && hdr[3] === 0xA3) {
          mimeType = 'audio/webm';
        } else if (hdr[0] === 0x4F && hdr[1] === 0x67 && hdr[2] === 0x67) {
          mimeType = 'audio/ogg';
        }
      }
      const blob = new Blob(chunks, { type: mimeType });
      setPlayerPath(URL.createObjectURL(blob));
    } catch (error) {
      console.log(`[AudioPlayer] streamResponseToPlayer: ${error}`);
    }
  }

  useEffect(() => { // executing the code only for first time.
    if (props.audioData) {
      setPlayerPath(props.audioData);
    } else if (props.greetingMode == 2 && geetingTitle == '') {
      setPlayerPath('');
    }
  }, [props.audioData]);

  useEffect(() => {
    if (props.greetingTitle) {
      setgeetingTitle(props.greetingTitle);
    }

  }, [props.greetingTitle])

  useEffect(() => {
   setfirstGreetFlag(true);
      setgreetingObject(props.greetingObject);

  }, [props.greetingObject])

  useEffect(() => {
    // get the audio file for playing.
    async function requestAudioFile() {
      if (!(props.audioData)) {
        if (props.greetingMode === 1) {
          setfirstGreetFlag(false);
          if (greetingObject && greetingObject.uploadType === 3) {
            setshowLoader(true);
            const apiResponse = await getAudioFileForTTS(props.uniqueId, props.greetingType, props.greetingId, props.fileName);
            if (apiResponse?.status === 200) {
              await streamResponseToPlayer(apiResponse, (chunks) => {
                setttswavFile(new Blob(chunks, { type: "audio/mpeg" }));
              });
            }
            setshowLoader(false);
          } else {
            setshowLoader(true);
            const apiResponse = await getAudioFileNew(props.uniqueId, props.greetingType, props.greetingId, props.fileName);
            if (apiResponse?.status === 200) {
              await streamResponseToPlayer(apiResponse);
            }
            setshowLoader(false);
          }
        } else if (props.greetingMode === 2) {
          setPlayerPath('');
        }
      }
    }
    if ((props.uniqueId?.toString().length ?? 0) > 0 && props.greetingType && props.greetingType !== 0 && greetingObject && Object.keys(greetingObject).length > 0 && firstGreetFlag) {
      requestAudioFile();
    }

  }, [props.greetingType, props.uniqueId, greetingObject, firstGreetFlag]);


  // Fetching the already existed Greeting based on greetingType, uniqueID(Groups- groupcode, Users- agentid), siteid.

  async function onEdit() {
    try {
      // get the existing greeetings information.
      let reqJSON = {
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        id: props.uniqueId,
        greeting_type: props.greetingType
      };
      let apiResponse = await getExistingGreetingsInfo(reqJSON);
      if (apiResponse.status === 200) {
        let info = await apiResponse.json();
        console.log(`response data::${JSON.stringify(info)}`);
        let keys = Object.keys(info);
        if (keys.length == 1) {
          info[keys[0]].forEach(element => {
            element.display = element?.display ?? element?.filename
          });
          setExistingGreetings(info[keys[0]]); // reading only one greeting information.
        }

      } else {
      }

    } catch (error) {
      console.log(`Unable to load the existed greetings: ${error}`);
    }

  }

  console.log("greeting Object::::::::::::: "+JSON.stringify(greetingObject));

  // Greeting Mode changes
  useEffect(() => {

    const isDefault =
      playerPath !== undefined && playerPath === '' && props.greetingMode !== 2;
    setGreetingMode(props.greetingMode);
    if (playerPath != undefined && playerPath !== '') {
      setGreetingMode(1); // 1 personalized
      if (props.setGreetingMode) { props.setGreetingMode(1); }

    } else if ((playerPath != undefined && playerPath === '' && props.greetingMode !== 2)) {
      setGreetingMode(2); // 2 Default
      if (props.setGreetingMode) { props.setGreetingMode(2); }
    }

    if (props.setAudioData) {
      props.setAudioData(isDefault ? '' : playerPath);
    }

  }, [props.greetingMode, playerPath])

  // greeting upload response handling.
  async function setApiResponse(resJSON) {
    try {
      console.log(`SetAPIResponse ::: ${JSON.stringify(resJSON ?? {})}`);
      setSuccessMsg(resJSON.message);
      if (resJSON.istts || resJSON.uploadType === 3) {
        setshowLoader(true);
        const apiResponse = await getAudioFileForTTS(resJSON?.uniqueId ?? props.uniqueId, (resJSON?.greeting_type ?? props.greetingType), resJSON?.greeting_id, resJSON?.fileName, null, (!resJSON?.isNew ? (greetingObject && greetingObject?.uploadType === 3 ? greetingObject : null) : null));
        if (apiResponse?.status === 200) {
          await streamResponseToPlayer(apiResponse, (chunks) => {
            setttswavFile(new Blob(chunks, { type: "audio/mpeg" }));
          });
        }
        setshowLoader(false);
      } else {
        setshowLoader(true);
        const apiResponse = await getAudioFileNew(resJSON?.uniqueId ?? props.uniqueId, (resJSON?.greeting_type ?? props.greetingType), resJSON?.greeting_id, resJSON?.fileName, null);
        console.log("test two :::::::::::::::", JSON.stringify(apiResponse));
        if (apiResponse?.status === 200 && resJSON?.greeting_id != 0) {
          await streamResponseToPlayer(apiResponse);
        } else {
          setPlayerPath('');
        }
        setshowLoader(false);
        if(!resJSON?.uploadType || resJSON?.uploadType !== 3){

        setgreetingObject(null);
        }
      }
    } catch (e) {
      setshowLoader(false);
    }

  }

  function setDynamicValues(Object) {
    setgreetingObject((prev) => ({
      ...(prev || {}),
      voice_type: Object.voice_type,
      text: Object.text,
      uploadType: 3,
      title: Object?.name ?? Object.display,
      display: Object?.name ?? Object.display,
      greeting_id: Object?.greeting_id ?? props?.greetingId,
      greeting_type: props?.greeting_type,
      greeting_mode: 1,
      id: props.uniqueId,
      filename:
        Object?.updatedfilename ??
        Object?.filename ??
        "",
    }));
  }

  console.log("test one latest:::::::::::::::", JSON.stringify(greetingObject))
  const basicRef = useRef(null);

  return (
    <>
      <div className="px-2">
        <div className="phoneselect width-100">
          <audio controlslist="nodownload" src={playerPath} controls className="audio-controls" preload="auto" />
          <div className="routing-per ">
            {/* <span className="d-inline-block text-truncate greetingtooltip" style={{ maxWidth: 250 }}>{ (geetingTitle != "") ? geetingTitle || t("personalized") : t("default")}</span> */}
              <div className="d-flex align-items-center">
             {showLoader && (
               <div className="mini-spinner" ref={basicRef} style={{ zIndex: "1029" }}>
                 <MDBLoadingManagement parentRef={basicRef} />
               </div>
             )}
            <span
              id={`greetingtooltip-${props.greetingType}`}
              className="d-inline-block text-truncate greetingtooltip"
              style={{ maxWidth: 250 }}
            >{(geetingTitle != "") ? geetingTitle || t("personalized") : t("default")}</span>
            </div>
            <span
              className={`routing-edit${showLoader ? " disable-edit" : ""}`}
              data-bs-toggle="modal"
              data-bs-target="#medialibrary-tabs"
              onClick={(e) => { ChangeEnableGreeting(1); onEdit(); }}
            >
              {t("edit")}
            </span>
            
          </div>
        </div>
      </div>

      {enableGreeting === 1 && (
        <PopupLoader
          size={"lg"}
          title={t(props.title)}
          content={<Greeting
            greetingType={props.greetingType}
            uniqueId={props.uniqueId}
            existingGreetings={existingGreetings}
            setApiResponse={setApiResponse}
            greetingMode={greetingMode}
            setPlayerPath={setPlayerPath}
            setgeetingTitle={setgeetingTitle}
            onClose={ChangeEnableGreeting}
            title={props.title}
            userFlag={props?.userFlag ?? false}
            huntFlag={props?.huntFlag ?? false}
            greetingObject={greetingObject && greetingObject.uploadType === 3 ? greetingObject : null}
            ttswavFile={ttswavFile}
            setDynamicValues={setDynamicValues}
            shareVMFlag={props?.shareVMFlag ?? false}
          />
          }
          onClose={ChangeEnableGreeting}
        />
      )}


      {successMsg !== '' && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={5000}
          onClose={() => setSuccessMsg('')}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{successMsg}</span>
        </MDBAlert>
      )}

      {/* <Tooltip anchorSelect=".greetingtooltip" place="bottom" className="exampleTooltip w-auto" style={{ maxWidth: '400px' }}>
        <div className="text-white text-left">
          { (geetingTitle != "") ? geetingTitle || t("personalized") : t("default")}
        </div>
      </Tooltip> */}
      <Tooltip
        anchorSelect={`#greetingtooltip-${props.greetingType}`}
        place="bottom"
        className="exampleTooltip w-auto"
        style={{ maxWidth: '400px' }}
      >
        <div className="text-white text-left">
          {(geetingTitle != "") ? geetingTitle || t("personalized") : t("default")}
        </div>
      </Tooltip>
    </>
  );




}